import { milestones } from "@/mocks/home";

const toneMeta: Record<string, { dot: string; text: string; chip: string }> = {
  live: { dot: "bg-primary-500", text: "text-primary-700", chip: "bg-primary-100 text-primary-700" },
  wait: { dot: "bg-secondary-400", text: "text-secondary-700", chip: "bg-secondary-100 text-secondary-800" },
  doubt: { dot: "bg-accent-500", text: "text-accent-700", chip: "bg-accent-100 text-accent-800" },
};

export default function Progress() {
  return (
    <section id="progress" className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:py-16">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="flex items-center gap-2 text-sm font-semibold text-primary-600">
              <span className="h-4 w-1 rounded bg-primary-500" />
              聚焦一条正在追的线
            </p>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              实时进展时间线
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-6 text-foreground-500">
            每一条被我们跟住的线索，都会把最新进展按时间留痕，直到后续发展彻底落定。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-6 lg:grid-cols-[0.9fr_1.1fr]">
          {/* 左：线索摘要卡（锚定） */}
          <div className="flex flex-col rounded-xl border border-background-200 bg-background-50 p-6 lg:sticky lg:top-24 lg:self-start">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
              <i className="ri-fire-line" />
              热门焦点线
            </span>
            <h3 className="mt-4 font-heading text-xl font-black leading-snug text-foreground-950 md:text-2xl">
              连锁咖啡「蓝海」门店翻红，能走多远？
            </h3>
            <p className="mt-3 text-sm leading-6 text-foreground-600">
              从门店排队被拍到加盟咨询激增，再到官方回应装修升级——这条翻红线仍在实时跟进中，相关信号正持续收集与交叉核验。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-2">
              <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">商业 · 舆情</span>
              <span className="rounded-full bg-background-100 px-3 py-1 text-xs text-foreground-500">更新于 09-05 09:40</span>
            </div>

            <div className="mt-6 border-t border-background-200 pt-5">
              <div className="flex items-center justify-between">
                <p className="text-xs font-semibold text-foreground-500">整体进度</p>
                <p className="text-xs font-semibold text-primary-600">第 6 轮 · 持续更新中</p>
              </div>
              <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-background-200">
                <div className="h-full w-[78%] rounded-full bg-gradient-to-r from-primary-500 to-accent-500" />
              </div>
            </div>

            <a
              href="#briefing"
              className="mt-7 flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-500"
            >
              继续跟进这条线
              <i className="ri-arrow-right-line" />
            </a>
          </div>

          {/* 右：竖向时间线 */}
          <ol className="relative flex flex-col gap-3 border-l-2 border-background-200 pl-6 md:pl-8">
            {milestones.map((m) => {
              const meta = toneMeta[m.tone];
              return (
                <li key={m.date + m.title} className="relative rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200">
                  <span className={`absolute -left-[35px] top-5 flex h-4 w-4 items-center justify-center rounded-full ${meta.dot} ring-4 ring-background-100 md:-left-[43px]`}>
                    <span className="h-1.5 w-1.5 rounded-full bg-background-50" />
                  </span>
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="font-heading text-sm font-black text-foreground-950">{m.date}</span>
                    <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${meta.chip}`}>{m.tag}</span>
                    <span className="ml-auto flex items-center gap-1 text-[11px] text-foreground-400">
                      <i className="ri-time-line" />已留痕
                    </span>
                  </div>
                  <h4 className="mt-2 text-[15px] font-bold text-foreground-950">{m.title}</h4>
                  <p className="mt-1 text-[13px] leading-6 text-foreground-600">{m.desc}</p>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}